/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useEffect, useRef } from 'react'
import { FormikProps } from 'formik'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Lightbox } from '@nexigendigital/nxui'
import { useUpdateProfileMutation } from 'api/account'
import { setUser } from 'store/slices/appSlice'
import { Address } from 'models/account'
import { useAppDispatch } from 'store/hooks'

import EditDetailsForm from 'containers/account/form/editProfileForm'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    status: boolean,
    close: () => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function EditProfileLightbox({ status, close }: Props) {
    const dispatch = useAppDispatch()
    const formRef = useRef<FormikProps<Partial<Address>>>(null)
    const [, { data, isLoading, isSuccess, isError }] = useUpdateProfileMutation({ fixedCacheKey: 'update-profile' })

    /**********************************************************************************************************
     *   SIDE EFFECTS
     **********************************************************************************************************/
    useEffect(() => {
        if (isSuccess) {
            close()
            dispatch(setUser(data))
        }

        if (isError && formRef.current) {
            formRef.current.setSubmitting(false)
            formRef.current.resetForm()
        }
    }, [isSuccess, isError, data])

    return (
        <Lightbox
            title={'Profile'}
            content={<EditDetailsForm form={formRef}/>}
            conditions={{ state: status, action: () => close() }}
            actions={[
                {
                    label: 'Back',
                    color: 'secondary',
                    func: () => close()
                },
                {
                    label: 'Update',
                    color: 'primary',
                    type: 'submit',
                    form: 'editDetailsForm',
                    loading: isLoading ? 'Updating' : false
                }
            ]}
        />
    )
}
